import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { defaultNS, resources, type SupportedLanguage, supportedLanguages } from '@/locales';

/** `en-GB`, `en` → `en-US`; qualquer outro idioma → `pt-BR` (os únicos com tradução). */
function toSupportedLanguage(detected: string): SupportedLanguage {
  return detected.toLowerCase().startsWith('en') ? 'en-US' : 'pt-BR';
}

// Leitor de tela e hifenização seguem o `lang` do documento, não o i18next.
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'pt-BR',
    supportedLngs: supportedLanguages,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: toSupportedLanguage,
    },
  });

/** Formato de data (date-fns) exibido no idioma ativo. */
export function displayDateFormat(language: string): string {
  return language === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
}

export default i18n;
